import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'PreDefinedAmounts',
  props: ['amounts', 'symbols', 'symbol'],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;
const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const setValue = (key, val) => {
  store[key] = val;
};
const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol
};
const convert = (amt) => {
  const { exchange_rates } = lifeline_donation
  const syb = getSymbol()
  if(_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt);
  }
  return amt
};

onMounted(() => {
  store.amount = null; // Ensure the amount is null on component mount
});

const __returned__ = { store, props, lifeline_donation, _, setValue, getSymbol, convert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})